module.exports = __webpack_public_path__ + "img/14.af4e99ba.jpg";